import React from "react";

const CTA = () => {
  return (
    <section className="bg-white py-16 sm:py-24 px-4 sm:px-6 md:px-12 font-serif">
      <div className="max-w-7xl mx-auto">

        {/* ── FLOATING CARD ── */}
        <div className="relative bg-black overflow-hidden">

          {/* Corner Bracket Accents */}
          <span className="absolute top-0 left-0 w-10 h-10 border-t-2 border-l-2 border-white/20" />
          <span className="absolute top-0 right-0 w-10 h-10 border-t-2 border-r-2 border-white/20" />
          <span className="absolute bottom-0 left-0 w-10 h-10 border-b-2 border-l-2 border-white/20" />
          <span className="absolute bottom-0 right-0 w-10 h-10 border-b-2 border-r-2 border-white/20" />

          {/* Decorative large watermark ampersand */}
          <div className="absolute -right-6 top-1/2 -translate-y-1/2 text-[14rem] font-black text-white/[0.03] select-none pointer-events-none leading-none font-serif">
            &
          </div>

          {/* Thin top line */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-20 h-[2px] bg-white/15" />

          <div className="relative z-10 flex flex-col lg:flex-row items-center justify-between gap-10 px-8 sm:px-14 md:px-20 py-14 sm:py-20">

            {/* LEFT: Text */}
            <div className="text-center lg:text-left max-w-xl">
              {/* Eyebrow */}
              <div className="flex items-center justify-center lg:justify-start gap-3 mb-5">
                <div className="w-6 h-[1px] bg-white/30" />
                <span className="text-[10px] uppercase tracking-[0.5em] text-white/40 font-sans font-bold">
                  Rai & Associates
                </span>
                <div className="w-6 h-[1px] bg-white/30" />
              </div>

              {/* Heading */}
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-tight mb-5">
                Facing a Legal Issue?{" "}
                <span className="font-light text-white/50 ">We Can Help.</span>
              </h2>

              {/* Divider */}
              <div className="w-10 h-[2px] bg-white/20 mx-auto lg:mx-0 mb-5" />

              {/* Subtext */}
              <p className="text-white/50 font-sans text-sm sm:text-base leading-relaxed">
                With over 20 years of courtroom mastery, Rai & Associates
                provides strategic, result-driven legal counsel across Delhi's
                highest courts. Your rights deserve the strongest defence.
              </p>
            </div>

            {/* RIGHT: Button block */}
            <div className="flex flex-col items-center gap-5 shrink-0">
              {/* Primary CTA */}
              <a
                href="/contact-us"
                className="inline-block px-10 py-4 bg-white text-black text-[11px] font-black uppercase tracking-[0.4em] hover:bg-transparent hover:text-white border border-white transition-all duration-400 text-center"
              >
                Schedule a Consultation
              </a>

              {/* Secondary — phone */}
              <a
                href="tel:+917042513698"
                className="flex items-center gap-3 group"
              >
                <span className="w-8 h-8 border border-white/20 flex items-center justify-center group-hover:bg-white/10 transition-all duration-300">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.67A2 2 0 012 .99h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 8.91a16 16 0 006.18 6.18l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
                  </svg>
                </span>
                <span className="text-white/50 text-xs font-sans uppercase tracking-[0.3em] group-hover:text-white/80 transition-colors duration-300">
                  +91 70425 13698
                </span>
              </a>
            </div>
          </div>

          {/* Thin bottom line */}
          <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-20 h-[2px] bg-white/15" />
        </div>

      </div>
    </section>
  );
};

export default CTA;